<!-- <p>delete works!</p> -->
<div class="modal fade" id="confirmDeleteModal" tabindex="-1" role="dialog" aria-labelledby="confirmDeleteModal"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Delete</h4>
        <button type="button" class="close">
          <img src="./assets/icons/close.svg" (click)="fnCloseConfirmDeleteModal()" alt="Close" />
        </button>
      </div>
      <div class="modal-body position-relative text-center px-0" *ngIf="deleteMessage == '' && !showLoader">
        <div class="content p-3 py-0">
          <div class="confirmation-message">
            <p class="text-muted f-14">{{ contentMessage }}</p>
          </div>
          <button type="button" class="btn btn-cancel" (click)="fnCloseConfirmDeleteModalAndEmit()"
            data-dismiss="modal">
            Cancel
          </button>
          <button type="button" class="btn btn-primary" (click)="fnDelete()">
            Confirm
          </button>
        </div>
      </div>
      <div class="modal-body p-5" *ngIf="showLoader">
        <div class="custom-loader">
          Please Wait
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </div>
      <div class="modal-body p-5" *ngIf="!showLoader && deleteMessage != ''">
        <div class="modal-success-message">
          <p class="d-inline-block text-capitalize">
            {{ deleteMessage }}
          </p>
          <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
            <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
            <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
          </svg>
        </div>
      </div>
    </div>
  </div>
</div>